<template>
  <header class="pt-20 max-w-md mx-auto">
    <h1 class="text-4xl font-bold mb-4 md:text-5xl"><span class="text-primaryColor">Reflex</span> Tracker</h1>
    <p class="mb-4 text-lg">
      Click on the pulsing circle as soon as it appears and measure your
      reaction time!
    </p>
  </header>
</template>
